import { useState } from 'react';
import { ModalHost } from './ModalHost';
import { ExportFormat } from '../../contracts/proof';
import { EXPORT_FORMATS, downloadProof } from '../../core/export';

interface ExportModalProps {
  isOpen: boolean;
  onClose: () => void;
  bridgeId?: string;
  bridgeName?: string;
}

export function ExportModal({
  isOpen,
  onClose,
  bridgeId,
  bridgeName,
}: ExportModalProps) {
  const [selectedFormat, setSelectedFormat] = useState<ExportFormat>(
    ExportFormat.JSON
  );
  const [isExporting, setIsExporting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleExport = async () => {
    if (!bridgeId) {
      setError('Please select a bridge first.');
      return;
    }
    setIsExporting(true);
    setError(null);
    try {
      await downloadProof(bridgeId, selectedFormat);
      onClose();
    } catch (err) {
      setError('Export failed. Please try again.');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <ModalHost isOpen={isOpen} onClose={onClose} title="Export Proof Packet">
      <div className="flex flex-col gap-4">
        <p className="text-sm text-secondary">
          Export forecast proof packet for {bridgeName}
        </p>

        <div>
          <label className="text-sm font-medium mb-2 block">Format</label>
          <div className="flex gap-2">
            {EXPORT_FORMATS.filter((f) =>
              [ExportFormat.JSON, ExportFormat.CSV, ExportFormat.PDF].includes(
                f.id
              )
            ).map((format) => (
              <button
                key={format.id}
                className={`btn ${
                  selectedFormat === format.id ? 'btn--primary' : 'btn--secondary'
                }`}
                onClick={() => setSelectedFormat(format.id)}
              >
                {format.label}
              </button>
            ))}
          </div>
        </div>

        {error && (
          <div className="text-sm text-error">
            {error}
          </div>
        )}

        <div className="modal-footer">
          <button className="btn btn--secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn--primary"
            onClick={handleExport}
            disabled={isExporting}
          >
            {isExporting ? 'Exporting...' : 'Export'}
          </button>
        </div>
      </div>
    </ModalHost>
  );
}
